import { Component, OnInit, Input, ChangeDetectorRef, ViewRef, ChangeDetectionStrategy } from '@angular/core';

import { FieldType } from "@ngx-formly/core";
import { AppStateService } from "src/app/core-module/services/app-state.service";
import { AloAocStateService } from "../../../core-module/services/state/alo-aoc-state.service";
import { FeatureDataStateService } from "../../../core-module/services/state/feature-data-state.service";
import { FeatureDefaultsStateService } from "../../../core-module/services/state/feature-defaults-state.service";
import { InputErrorsStateService } from "../../../core-module/services/state/input-errors-state.service";
@Component({
  standalone: false,
  selector: "app-dali-m",
  templateUrl: "./dali-m.component.html",
  styleUrls: ["./dali-m.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DaliMComponent extends FieldType implements OnInit {
  @Input() field;
  column: LegacyAny;
  properties: LegacyAny;
  ngModelval: LegacyAny = [];
  JSONOb: LegacyAny = [];
  inputError: LegacyAny = [];
  quickConfigCustomCSS;
  diia253maintenanceDefaultColor;
  setQuickConfig;
  isEdited: LegacyAny;
  RatedLifeValueMin: LegacyAny;
  RatedLifeValueMax: LegacyAny;
  RatedLife: LegacyAny;
  ReferenceTemperatureValueMin: LegacyAny;
  ReferenceTemperatureValueMax: LegacyAny;
  reqiredProperties: LegacyAny;
  maskMaximum: LegacyAny = {
    RatedStarts: 65535,
    RatedLife: 255,
    ReferenceTemperature: 195,
  };
  ReferenceTemperature: LegacyAny;
  RatedStarts: LegacyAny;
  RatedStartsValueMin: LegacyAny;
  RatedStartsValueMax: LegacyAny;
  fileResponse: LegacyAny;
  diia253maintenanceCreateFile: boolean;
  constructor(
    private ref: ChangeDetectorRef, private appState: AppStateService,
    private featureDefaults: FeatureDefaultsStateService,
    private inputErrors: InputErrorsStateService,
    private featureData: FeatureDataStateService,
    private aloAoc: AloAocStateService
  ) {
    super();
  }
  valueChanged(fieldName?) {
    for (let j = 0; j < this.JSONOb.length; j++) {
      if (
        parseInt(this.ngModelval[fieldName]) ===
          parseInt(this.maskMaximum[fieldName]) &&
        this.JSONOb[j].key == fieldName
      ) {
        delete this.JSONOb[j];
        this.ngModelval[fieldName] = "";
        this.JSONOb.push({ key: fieldName, value: this.ngModelval[fieldName] });
        this.senddiia253maintenancedata(this.ngModelval);
        this.diia253maintenanceDefaultColor = true;
        this.featureDefaults.setdiia253maintenanceDefaultColor(
          this.diia253maintenanceDefaultColor
        );
      }
    }
  }
  RatedLifevalueChanged(value, fieldName?) {
    this.inputError["RatedLife"] = false;
    this.ngModelval["RatedLife"] = value;

    const isDefaultValue = value == this.field["properties"]["RatedLife"]["default"];
    const isInValidRange = value >= this.RatedLifeValueMin && value <= this.RatedLifeValueMax;

    if (isDefaultValue) {
      this.valueChanged(fieldName);
    } else if (!isInValidRange) {
      this.inputError["RatedLife"] = true;
      this.inputErrors.senddiia253maintenanceInputError(true);
    }

    this.senddiia253maintenancedata(this.ngModelval);
    this.checkInvalidValues();
    this.checkdfault();
  }
  ReferenceTemperaturevalueChanged(value, fieldName?) {
    this.inputError["ReferenceTemperature"] = false;
    this.ngModelval["ReferenceTemperature"] = value;

    const isDefaultValue = value == this.field["properties"]["ReferenceTemperature"]["default"];
    const isInValidRange = value >= this.ReferenceTemperatureValueMin && value <= this.ReferenceTemperatureValueMax;

    if (isDefaultValue) {
      this.valueChanged(fieldName);
    } else if (!isInValidRange) {
      this.inputError["ReferenceTemperature"] = true;
      this.inputErrors.senddiia253maintenanceInputError(true);
    }

    this.senddiia253maintenancedata(this.ngModelval);
    this.checkInvalidValues();
    this.checkdfault();
  }
  RatedStartsvalueChanged(value, fieldName?) {
    this.inputError["RatedStarts"] = false;
    this.ngModelval["RatedStarts"] = value;

    const isDefaultValue = value == this.field["properties"]["RatedStarts"]["default"];
    const isInValidRange = value >= this.RatedStartsValueMin && value <= this.RatedStartsValueMax;

    if (isDefaultValue) {
      this.valueChanged(fieldName);
    } else if (!isInValidRange) {
      this.inputError["RatedStarts"] = true;
      this.inputErrors.senddiia253maintenanceInputError(true);
    }

    this.senddiia253maintenancedata(this.ngModelval);
    this.checkInvalidValues();
    this.checkdfault();
  }
  checkInvalidValues() {
    this.diia253maintenanceCreateFile = false;
    for (const type in this.inputError) {
      if (this.inputError[type]) {
        this.diia253maintenanceCreateFile = true;
      }
    }
    this.featureData.diia253maintenanceInputError(
      this.diia253maintenanceCreateFile
    );
    this.inputErrors.senddiia253maintenanceInputError(
      this.diia253maintenanceCreateFile
    );
  }
  checkdfault() {
    if (!this.properties) {
      return;
    }

    // Rebuild JSONOb array only with required properties
    this.JSONOb = this.reqiredProperties.map(type => ({
      key: type,
      value: this.ngModelval[type]
    }));

    // Check if LegacyAny field has been modified from default
    // Only consider a field modified if it's initialized (not null/undefined) AND not empty
    const isRatedLifeModified =
      this.properties.RatedLife.default === this.field.allOf[0].if.properties.RatedLife.const &&
      this.ngModelval["RatedLife"] != null &&
      this.ngModelval["RatedLife"] !== "";

    const isReferenceTemperatureModified =
      this.properties.ReferenceTemperature.default === this.field.allOf[1].if.properties.ReferenceTemperature.const &&
      this.ngModelval["ReferenceTemperature"] != null &&
      this.ngModelval["ReferenceTemperature"] !== "";

    const isRatedStartsModified =
      this.properties.RatedStarts.default === this.field.allOf[2].if.properties.RatedStarts.const &&
      this.ngModelval["RatedStarts"] != null &&
      this.ngModelval["RatedStarts"] !== "";

    this.diia253maintenanceDefaultColor = !(isRatedLifeModified || isReferenceTemperatureModified || isRatedStartsModified);

    this.featureDefaults.setdiia253maintenanceDefaultColor(this.diia253maintenanceDefaultColor);
    this.featureData.diia253maintenanceEditedVal(this.diia253maintenanceDefaultColor);
  }
  resetDefaultdiia253maintenance() {
    if (
      this.properties != null &&
      this.properties.RatedLife != null &&
      this.properties.RatedLife.default ===
        this.field.allOf[0].if.properties.RatedLife.const
    ) {
      this.ngModelval["RatedLife"] = "";
      this.inputError["RatedLife"] = false;
    }
    if (
      this.properties != null &&
      this.properties.ReferenceTemperature != null &&
      this.properties.ReferenceTemperature.default ===
        this.field.allOf[1].if.properties.ReferenceTemperature.const
    ) {
      this.ngModelval["ReferenceTemperature"] = "";
      this.inputError["ReferenceTemperature"] = false;
    }
    if (
      this.properties != null &&
      this.properties.RatedStarts != null &&
      this.properties.RatedStarts.default ===
        this.field.allOf[2].if.properties.RatedStarts.const
    ) {
      this.ngModelval["RatedStarts"] = "";
      this.inputError["RatedStarts"] = false;
    }
    this.inputErrors.senddiia253maintenanceInputError(false);
    this.inputErrors.setdiia253maintenanceEditedData(this.ngModelval);
    this.senddiia253maintenancedata(this.ngModelval);
    this.ref.markForCheck();
  }
  ngOnInit() {
    this.isEdited = false;
    this.featureDefaults.getdiia253maintenanceDefaultValue.subscribe((response) => {
      if (response == "valid") {
        this.diia253maintenanceDefaultColor = true;
        this.resetDefaultdiia253maintenance();
      }
    });
    this.column = this.field.requiredProperties;
    this.properties = this.field.properties;
    this.reqiredProperties = this.field.requiredProperties;
    this.RatedLifeValueMin =
      this.field.allOf[0].else.properties.RatedLife.minimum;
    this.RatedLifeValueMax =
      this.field.allOf[0].else.properties.RatedLife.maximum;
    if (
      this.properties.RatedLife.default ===
      this.field.allOf[0].if.properties.RatedLife.const
    ) {
      this.ngModelval["RatedLife"] = "";
    }
    this.ReferenceTemperatureValueMin =
      this.field.allOf[1].else.properties.ReferenceTemperature.minimum;
    this.ReferenceTemperatureValueMax =
      this.field.allOf[1].else.properties.ReferenceTemperature.maximum;
    if (
      this.properties.ReferenceTemperature.default ===
      this.field.allOf[1].if.properties.ReferenceTemperature.const
    ) {
      this.ngModelval["ReferenceTemperature"] = "";
    }
    this.RatedStartsValueMin =
      this.field.allOf[2].else.properties.RatedStarts.minimum;
    this.RatedStartsValueMax =
      this.field.allOf[2].else.properties.RatedStarts.maximum;
    if (
      this.properties.RatedStarts.default ===
      this.field.allOf[2].if.properties.RatedStarts.const
    ) {
      this.ngModelval["RatedStarts"] = "";
    }

    const unSelectedFeat = this.appState.getUnSelectedFeatConfig();

    let isConfigEdited = false;
    let featIndex: number = 0;
    if (unSelectedFeat != null) {
      unSelectedFeat.forEach((element) => {
        if (
          element != null &&
          element["featureName"] != null &&
          element["featureName"].toString().toUpperCase() ===
            "DIIA253MAINTENANCE"
        ) {
          isConfigEdited = true;
          const DIIA253MAINTENANCE: LegacyAny = element["featureParameters"][0];
          this.isEdited = true;
          this.adddiia253maintenanceLoadedFeatureReadValues(DIIA253MAINTENANCE);
          unSelectedFeat.splice(featIndex, 1);
          this.appState.setUnSelectedFeatConfig(unSelectedFeat);
        } else {
          featIndex++;
        }
      });
    }

    this.aloAoc.getquickConfig.subscribe((data) => {
      if (data === "quickConfig") {
        this.quickConfigCustomCSS = "custom-inputbox";
        this.setQuickConfig = "quickConfig";
      } else if (data === "standard") {
        this.quickConfigCustomCSS = "custom-inputbox";
        this.setQuickConfig = "standard";
      }
      setTimeout(() => {
        if (this.ref && !(this.ref as ViewRef).destroyed) {
          this.ref.detectChanges();
        }
      });
    });

    if (!isConfigEdited) {
      setTimeout(() => {
        // Use centralized method to get feature data
        // Try different case variations for backward compatibility
        const daliData = this.appState.getFeatureData('diia253maintenance') ||
                         this.appState.getFeatureData('Diia253Maintenance') ||
                         this.appState.getFeatureData('DiiA253Maintenance');

        if (daliData) {
          this.adddiia253maintenanceLoadedFeatureReadValues(daliData);
        }
      }, 1000);
    }
    setTimeout(() => {
      this.senddiia253maintenancedata(this.ngModelval);
      this.isEdited = true;
    }, 1000);
  }
  adddiia253maintenanceLoadedFeatureReadValues(diia253maintenance: LegacyAny) {
    const diia253maintenanceObj = diia253maintenance;
    const keys = Object.keys(diia253maintenanceObj);
    const values = Object.values(diia253maintenanceObj);

    // First, set all values in ngModelval and clear errors without triggering validation
    const result = [];
    keys.forEach((key, i) => (result[key] = values[i]));

    // Apply default value logic for each field
    this.ngModelval["RatedLife"] =
      result["RatedLife"] === "" || result["RatedLife"] === 255
        ? ""
        : result["RatedLife"];
    this.ngModelval["ReferenceTemperature"] =
      result["ReferenceTemperature"] === "" ||
      result["ReferenceTemperature"] === 195
        ? ""
        : result["ReferenceTemperature"];
    this.ngModelval["RatedStarts"] =
      result["RatedStarts"] === "" || result["RatedStarts"] === 65535
        ? ""
        : result["RatedStarts"];

    // Clear all input errors for loaded values
    this.inputError["RatedLife"] = false;
    this.inputError["ReferenceTemperature"] = false;
    this.inputError["RatedStarts"] = false;

    // Validate each field's range
    if (this.ngModelval["RatedLife"] !== "") {
      const value = this.ngModelval["RatedLife"];
      if (value < this.RatedLifeValueMin || value > this.RatedLifeValueMax) {
        this.inputError["RatedLife"] = true;
      }
    }
    if (this.ngModelval["ReferenceTemperature"] !== "") {
      const value = this.ngModelval["ReferenceTemperature"];
      if (value < this.ReferenceTemperatureValueMin || value > this.ReferenceTemperatureValueMax) {
        this.inputError["ReferenceTemperature"] = true;
      }
    }
    if (this.ngModelval["RatedStarts"] !== "") {
      const value = this.ngModelval["RatedStarts"];
      if (value < this.RatedStartsValueMin || value > this.RatedStartsValueMax) {
        this.inputError["RatedStarts"] = true;
      }
    }

    // Update model if it exists
    if (this.model) {
      this.model["RatedLife"] = this.ngModelval["RatedLife"];
      this.model["ReferenceTemperature"] = this.ngModelval["ReferenceTemperature"];
      this.model["RatedStarts"] = this.ngModelval["RatedStarts"];
    }

    // Now that all values are set, perform validation once
    this.checkInvalidValues();
    this.checkdfault();
    this.senddiia253maintenancedata(this.ngModelval);
    this.ref.markForCheck();
  }
  setConfigurationData(value, keyVal) {
    // Use centralized method to save feature data
    // This automatically saves to both ConfigurationData and SaveSetData
    const diia253maintenanceObj = Object.assign({}, value);
    this.appState.setFeatureData(keyVal, diia253maintenanceObj);
  }
  senddiia253maintenancedata(val) {
    this.featureData.senddiia253maintenancedata(val);
    if (this.isEdited) {
      this.setConfigurationData(this.ngModelval, "diia253maintenance");
    }
  }
  ngOnDestroy() {
    this.featureData.senddiia253maintenancedata("");
  }
  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    return !(charCode > 31 && (charCode < 48 || charCode > 57));
  }
  numbersAll(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    return !(charCode > 31 && (charCode < 44 || charCode > 57));
  }

  blockNonNumericPaste(event: ClipboardEvent) {
    const pastedInput: string = event.clipboardData?.getData('text') ?? '';
    if (!/^\d+$/.test(pastedInput)) {
      event.preventDefault();
    }
  }

}

